import '../FiscalLayout.css';
import IonAlert from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonPage, IonTextarea, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, warningOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import {
    fiscalInutilizarNumeracao,
    requestService
} from '../../../../../Utils/Services';
import './FiscalInutilizacao.css';

type Props = {
    abrirMenu: boolean;
};

const FiscalInutilizacao: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    const [serie, setSerie] = useState("1");
    const [numeroInicial, setNumeroInicial] = useState("");
    const [numeroFinal, setNumeroFinal] = useState("");
    const [justificativa, setJustificativa] = useState("");
    const [ano, setAno] = useState(String(new Date().getFullYear()));

    const [showLoading, setShowLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [toastColor, setToastColor] = useState("success");
    const [showConfirmAlert, setShowConfirmAlert] = useState(false);

    // Resultado
    const [resultadoInutilizacao, setResultadoInutilizacao] = useState<any>(null);
    const [erroInutilizacao, setErroInutilizacao] = useState<{ mensagem: string; status?: string } | null>(null);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

    useIonViewDidEnter(() => {
        if (acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao') {
            history.replace('/empresa/home');
            return;
        }
        setEsconderMenu(true);
        setNomeMenu("");
        setResultadoInutilizacao(null);
        setErroInutilizacao(null);
    });

    function validar(): boolean {
        if (!serie) { mostrarToast("Informe a série.", "warning"); return false; }
        if (!numeroInicial) { mostrarToast("Informe o número inicial.", "warning"); return false; }
        if (!numeroFinal) { mostrarToast("Informe o número final.", "warning"); return false; }
        if (parseInt(numeroInicial) > parseInt(numeroFinal)) {
            mostrarToast("Número inicial deve ser menor ou igual ao final.", "warning");
            return false;
        }
        if (justificativa.length < 15) {
            mostrarToast("A justificativa deve ter no mínimo 15 caracteres.", "warning");
            return false;
        }
        return true;
    }

    function confirmarInutilizacao() {
        if (!validar()) return;
        setErroInutilizacao(null);
        setShowConfirmAlert(true);
    }

    function inutilizar() {
        setShowLoading(true);

        requestService(
            fiscalInutilizarNumeracao.url,
            {
                method: fiscalInutilizarNumeracao.method,
                body: JSON.stringify({
                    empresaId: loja,
                    serie: serie,
                    numeroInicial: Number(numeroInicial),
                    numeroFinal: Number(numeroFinal),
                    justificativa: justificativa,
                    ano: ano
                }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setShowLoading(false);
                const dados = response.dados || response;
                if (dados.sucesso === false) {
                    const msg = dados.mensagem || dados.respostaCompleta?.retInutNFe?.infInut?.xMotivo || "Erro ao inutilizar numeração.";
                    const status = dados.status || dados.respostaCompleta?.retInutNFe?.infInut?.cStat;
                    setErroInutilizacao({ mensagem: msg, status: status ? String(status) : undefined });
                    return;
                }
                setErroInutilizacao(null);
                setResultadoInutilizacao(dados);
                mostrarToast("Numeração inutilizada com sucesso!", "success");
            },
            (error: any) => {
                setShowLoading(false);
                setErroInutilizacao({ mensagem: error.message || "Erro ao inutilizar numeração." });
            }
        );
    }

    function mostrarToast(msg: string, color: string) {
        setTextToast(msg);
        setToastColor(color);
        setShowToast(true);
    }

    return (
        <IonPage className="fiscal-layout">
            <IonHeader className="ion-no-border">
                <IonToolbar className="fiscal-layout-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Inutilização de Numeração</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="fiscal-inutilizacao-container">
                <div className="fiscal-layout-container"><div className="fiscal-layout-heading"><h1>Inutilização de numeração</h1><p>Informe a faixa de números e a justificativa para a inutilização.</p></div>

                <div className="fiscal-inutilizacao-info">
                    <p>
                        <IonIcon icon={warningOutline} style={{ verticalAlign: "middle", marginRight: "6px" }} />
                        A inutilização é obrigatória quando há salto de numeração nas notas fiscais. Esta ação é irreversível.
                    </p>
                </div>

                {erroInutilizacao && (
                    <IonCard className="fiscal-inutilizacao-form">
                        <IonCardHeader>
                            <IonCardTitle style={{ fontSize: "18px", color: "#d32f2f" }}>Erro na inutilização</IonCardTitle>
                            {erroInutilizacao.status && (
                                <IonCardSubtitle>Código SEFAZ: {erroInutilizacao.status}</IonCardSubtitle>
                            )}
                        </IonCardHeader>
                        <IonCardContent>
                            <div style={{
                                background: "#fff3f3",
                                border: "1px solid #f44336",
                                borderRadius: "8px",
                                padding: "12px 14px",
                                marginBottom: "16px",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "10px"
                            }}>
                                <IonIcon icon={warningOutline} color="danger" style={{ fontSize: "22px", flexShrink: 0, marginTop: "2px" }} />
                                <p style={{ margin: 0, fontSize: "14px", color: "#c62828", lineHeight: "1.5" }}>
                                    {erroInutilizacao.mensagem}
                                </p>
                            </div>
                            <IonButton color="primary" expand="block" onClick={() => setErroInutilizacao(null)}>
                                Tentar novamente
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                )}

                {!erroInutilizacao && (resultadoInutilizacao ? (
                    <IonCard className="fiscal-inutilizacao-form">
                        <IonCardHeader>
                            <IonCardTitle style={{ fontSize: "18px", color: "#4caf50" }}>Inutilização realizada!</IonCardTitle>
                            <IonCardSubtitle>Protocolo: {resultadoInutilizacao.protocolo || "—"}</IonCardSubtitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p>Série: {serie}</p>
                            <p>Números: {numeroInicial} a {numeroFinal}</p>
                            <IonButton color="primary" expand="block" style={{ marginTop: "16px" }} onClick={() => {
                                setResultadoInutilizacao(null);
                                setErroInutilizacao(null);
                                setNumeroInicial("");
                                setNumeroFinal("");
                                setJustificativa("");
                            }}>
                                Nova inutilização
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                ) : (
                    <IonCard className="fiscal-inutilizacao-form">
                        <IonCardContent>
                            <IonList>
                                <div className="fiscal-field" >
                                    <label className="fiscal-field-label">Ano *</label>
                                    <IonInput value={ano} onIonChange={(e) => setAno(e.detail.value || "")} type="number" maxlength={4} />
                                </div>
                                <div className="fiscal-field" >
                                    <label className="fiscal-field-label">Série *</label>
                                    <IonInput value={serie} onIonChange={(e) => setSerie(e.detail.value || "")} placeholder="Ex: 1" />
                                </div>
                                <div className="fiscal-field" >
                                    <label className="fiscal-field-label">Número Inicial *</label>
                                    <IonInput value={numeroInicial} onIonChange={(e) => setNumeroInicial(e.detail.value || "")} type="number" placeholder="Ex: 1" />
                                </div>
                                <div className="fiscal-field" >
                                    <label className="fiscal-field-label">Número Final *</label>
                                    <IonInput value={numeroFinal} onIonChange={(e) => setNumeroFinal(e.detail.value || "")} type="number" placeholder="Ex: 10" />
                                </div>
                                <div className="fiscal-field" >
                                    <label className="fiscal-field-label">Justificativa (mínimo 15 caracteres) *</label>
                                    <IonTextarea
                                        value={justificativa}
                                        onIonChange={(e) => setJustificativa(e.detail.value || "")}
                                        placeholder="Motivo da inutilização..."
                                        rows={3}
                                    />
                                </div>
                            </IonList>

                            <div className={`fiscal-char-counter ${justificativa.length < 15 ? 'invalid' : ''}`}>
                                {justificativa.length}/15 caracteres mínimos
                            </div>

                            <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" color="primary" onClick={confirmarInutilizacao} style={{ marginTop: "16px" }}>
                                Inutilizar numeração
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                ))}

                <IonAlert
                    isOpen={showConfirmAlert}
                    onDidDismiss={() => setShowConfirmAlert(false)}
                    header="Confirmar inutilização"
                    message={`Deseja realmente inutilizar os números ${numeroInicial} a ${numeroFinal} da série ${serie}? Esta ação é irreversível.`}
                    buttons={[
                        { text: 'Cancelar', role: 'cancel' },
                        { text: 'Inutilizar', cssClass: 'primary', handler: () => inutilizar() }
                    ]}
                />

                <IonLoading isOpen={showLoading} message="Inutilizando numeração..." />

                <IonToast
                    isOpen={showToast}
                    position="top"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                    color={toastColor}
                />
            </div>
            </IonContent>
        </IonPage>
    );
};

export default FiscalInutilizacao;
